import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Content = styled.div`
  padding: 40px 50px 50px;
  width: 500px;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 100%;
    min-width: 0;
    padding: 20px 0;
  }
`;

export const Title = styled(Typography.Header)`
  margin: 0 0 32px;
  color: ${({ theme }) => theme.palette.primary.labels};
  font-size: 22px;
  font-weight: 700;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  font-size: 15px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.primary.labels};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const Day = styled.span``;

export const Hours = styled.span`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const TitleRow = styled.div`
  position: relative;
  margin-bottom: 20px;
`;
